import React from 'react';

import { Checkbox, Label, LabeledControl, Switch } from '@zillow/constellation';

import { hyphenateString } from '../../utils/stringParsing';

type Props = {
  text: string;
  onClick: () => void;
  toggled: boolean;
  disabled?: boolean;
};

export default function SwitchWithTitle({ text, onClick, toggled, disabled }: Props): JSX.Element {
  const controlId = hyphenateString(text);

  return (
    <LabeledControl
      fluid
      controlId={controlId}
      size="lg"
      labelPosition="left"
      disabled={disabled}
      label={<Label data-test="subheader">{text}</Label>}
      control={
        <Switch
          aria-label={controlId}
          onClick={disabled ? null : onClick}
          data-test="headerToggleSwitch"
          checkbox={<Checkbox checked={toggled} />}
        />
      }
    />
  );
}
